import { render, staticRenderFns } from "./additional-modifiers.vue?vue&type=template&id=9adc7748&scoped=true"
import script from "./additional-modifiers.vue?vue&type=script&lang=js"
export * from "./additional-modifiers.vue?vue&type=script&lang=js"
import style0 from "./additional-modifiers.vue?vue&type=style&index=0&id=9adc7748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adc7748",
  null
  
)

export default component.exports